import { render, staticRenderFns } from "./dashboard-card.vue?vue&type=template&id=618ef61e&"
import script from "./dashboard-card.vue?vue&type=script&lang=js&"
export * from "./dashboard-card.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VCard,VCardText,VDivider,VIcon,VSheet,VSparkline})
